// extracted by mini-css-extract-plugin
module.exports = {"main":"Landing_main__3iT3q","info":"Landing_info__XYEt3"};